import React, { useState, useEffect } from "react";

import {Accordion, AccordionDetails, AccordionSummary, TextField, FormControl, FormLabel, FormGroup, Checkbox, FormControlLabel} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MultilineRegulationsTextArea from '../../../Container/multiline-regulations-text-area'
import config from '../../../hoa-config';
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";
interface HoaNuisanceFormProps {
    handleChange : any;
    values: any;
}

export default function HoaNuisanceForm(props: HoaNuisanceFormProps) {
    const {handleChange, values} = props;
    const { isNuisanceFiledDisabled } = useFieldDisabled();

    const stateList : any = {
        allowedOccupancyOfGuests : '',
        loudResidentsRestrictedOptions : [],
        loudAnimalsRestrictedOptions : [],
        offensiveBehaviorRestrictedOptions : [],
        regulationsOfGuests: '',
        regulationsOfGetTogether: '',
        regulationOfAnimalsCommercial: '',
        regulationsOfDogHouses: '',
        regulationsOfDischargeOfFirearms: '',
        instructionsOfCelebrationCertainFestivals: ''
    }

    const [state, setState] = useState(stateList);
    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [isWaring, setIsWarning] = useState(false);
    const [fieldInfo, setFieldInfo] = useState({
        field: '',
        key: '',
    });

    useEffect(() => {
        if (values) {
            let tempState = { ...state };
            Object.keys(tempState).map((key) => {
                tempState[key] = values[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            setState(tempState);
        }
    }, [values])

    const handleCurrentChange = (value: any, key: string, checkBoxSelectedKey:string = '') => {
        let tempState: any = { ...state };
        tempState[key] = value;
        if(checkBoxSelectedKey && config.violationRegulations[checkBoxSelectedKey]) {
            tempState[config.violationRegulations[checkBoxSelectedKey]] = '';
        }
        setState(tempState);
        handleChange(tempState, 'nuisance');
    }

    const handleCheckBoxGroup = (checked: boolean, key: string, stateName : string, regulation?: string) => {
        if (!checked && regulation) {
            setFieldInfo({
                field: stateName,
                key: key,
            });
            setIsWarning(!isWaring);

        } else {
            let tempValue = state[stateName];
            if(checked && !tempValue.includes(key)){
                tempValue.push(key);
            } else if(!checked && tempValue.includes(key)){
                tempValue = tempValue.filter((value: any) => {return value !== key})
            }
            handleCurrentChange(tempValue, stateName, key);
        }
    }

    const unCheckWarningYesClick = () => {
        let tempValue = state[fieldInfo.field];
        if(tempValue.includes(fieldInfo.key)){
            tempValue = tempValue.filter((value: any) => {return value !== fieldInfo.key})
        }
        handleCurrentChange(tempValue, fieldInfo.field, fieldInfo.key);
        setIsWarning(false);
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }

    return (
        <>
            <Accordion
            style={{background: expanded1 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded1(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Loud Residents
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                    <span style={{ fontSize:'1rem', marginBottom:'5px'}}>Guests Details</span>
                    <TextField 
                        style={{ width: '70%', marginRight: "20px", height: '64px' }} 
                        variant="standard" 
                        label="Allowed Occupancy Of Guests" 
                        value={state.allowedOccupancyOfGuests} 
                        type='number'
                        onChange={(e) => { handleCurrentChange(e.target.value, "allowedOccupancyOfGuests") }} 
                        onWheel={e => Wheel(e)} 
                        InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }} 
                        disabled={isNuisanceFiledDisabled("allowedOccupancyOfGuests")}
                    />
                    <MultilineRegulationsTextArea
                        regulationType={'regulationsOfGuests'}
                        value={state.regulationsOfGuests}
                        handleCurrentChange={handleCurrentChange}
                        disabled={isNuisanceFiledDisabled("regulationsOfGuests")}
                    />
                </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded2 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded2(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Animals
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.loudAnimalsRestrictedOptions.includes('Animal Regulations and Commercial Use')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Animal Regulations and Commercial Use', 'loudAnimalsRestrictedOptions', state.regulationOfAnimalsCommercial)}
                                    disabled={isNuisanceFiledDisabled("loudAnimalsRestrictedOptions") || isNuisanceFiledDisabled("regulationOfAnimalsCommercial")}
                                />
                            }
                            label="Animal Regulations and Commercial Use"
                        />
                        {
                            state.loudAnimalsRestrictedOptions.includes('Animal Regulations and Commercial Use') &&
                            <MultilineRegulationsTextArea
                                regulationType={'regulationOfAnimalsCommercial'}
                                value={state.regulationOfAnimalsCommercial}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isNuisanceFiledDisabled("regulationOfAnimalsCommercial")}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.loudAnimalsRestrictedOptions.includes('Unleashed Animals')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Unleashed Animals', 'loudAnimalsRestrictedOptions')} 
                                    disabled={isNuisanceFiledDisabled("loudAnimalsRestrictedOptions")}
                                />
                            }
                            label="Unleashed Animals"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.loudAnimalsRestrictedOptions.includes('Dog Houses')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Dog Houses', 'loudAnimalsRestrictedOptions', state.regulationsOfDogHouses)} 
                                    disabled={isNuisanceFiledDisabled("loudAnimalsRestrictedOptions") || isNuisanceFiledDisabled("regulationsOfDogHouses")}
                                />
                            }
                            label="Dog Houses"
                        />
                        {
                            state.loudAnimalsRestrictedOptions.includes('Dog Houses') &&
                            <MultilineRegulationsTextArea
                                regulationType={'regulationsOfDogHouses'}
                                value={state.regulationsOfDogHouses}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isNuisanceFiledDisabled("regulationsOfDogHouses")}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.loudAnimalsRestrictedOptions.includes('Pet Excrements')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Pet Excrements', 'loudAnimalsRestrictedOptions')} 
                                    disabled={isNuisanceFiledDisabled("loudAnimalsRestrictedOptions")}
                                />
                            }
                            label="Pet Excrements"
                        />
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded3 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded3(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Offensive Behaviors
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Interfering with peaceful possession')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Interfering with peaceful possession', 'offensiveBehaviorRestrictedOptions')}
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions")}
                                />
                            }
                            label="Interfering with peaceful possession"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Discharge of Firearms')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Discharge of Firearms', 'offensiveBehaviorRestrictedOptions', state.regulationsOfDischargeOfFirearms)} 
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions") || isNuisanceFiledDisabled("regulationsOfDischargeOfFirearms")}
                                />
                            }
                            label="Discharge of Firearms"
                        />
                        {
                            state.offensiveBehaviorRestrictedOptions.includes('Discharge of Firearms') &&
                            <MultilineRegulationsTextArea
                                regulationType={'regulationsOfDischargeOfFirearms'}
                                value={state.regulationsOfDischargeOfFirearms}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isNuisanceFiledDisabled("regulationsOfDischargeOfFirearms")}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Objects emitting loud noise, noxious odors')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Objects emitting loud noise, noxious odors', 'offensiveBehaviorRestrictedOptions')} 
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions")}
                                />
                            }
                            label="Objects emitting loud noise, noxious odors"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Business or commercial use of property')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Business or commercial use of property', 'offensiveBehaviorRestrictedOptions')} 
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions")}
                                />
                            }
                            label="Business or commercial use of property"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Drying of clothing in or around the property')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Drying of clothing in or around the property', 'offensiveBehaviorRestrictedOptions')} 
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions")}
                                />
                            }
                            label="Drying of clothing in or around the property"
                        />
                        </FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.offensiveBehaviorRestrictedOptions.includes('Celebration of certain festivals')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Celebration of certain festivals', 'offensiveBehaviorRestrictedOptions', state.instructionsOfCelebrationCertainFestivals)} 
                                    disabled={isNuisanceFiledDisabled("offensiveBehaviorRestrictedOptions") || isNuisanceFiledDisabled("instructionsOfCelebrationCertainFestivals")}
                                />
                            }
                            label="Celebration of certain festivals"
                        />
                        {
                            state.offensiveBehaviorRestrictedOptions.includes('Celebration of certain festivals') &&
                            <MultilineRegulationsTextArea
                                label="Instructions"
                                regulationType={'instructionsOfCelebrationCertainFestivals'}
                                value={state.instructionsOfCelebrationCertainFestivals}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isNuisanceFiledDisabled("instructionsOfCelebrationCertainFestivals")}
                            />
                        }
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </>
    )
}